import React from 'react';
import { GHOST_VARIANT } from '@yme/atoms/button';
import { ButtonLink } from '@yme/molecules/buttons';
import { colorCoreBlack300, colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { NoLuckDescription, NoLuckHeader } from './styled';
export function NoLuckComponent({ contactUsPanelTitle, contactUsPanelDescription, messageUsButton, }) {
    return (React.createElement(FlexWrapper, { flexDirection: "column", bg: colorCoreWhite1000, paddingDesktop: "48px", paddingTablet: "24px", paddingMobile: "24px 16px" },
        React.createElement(NoLuckHeader, null, contactUsPanelTitle),
        React.createElement(NoLuckDescription, { color: colorCoreBlack300 }, contactUsPanelDescription),
        React.createElement(ButtonLink, { buttonLink: messageUsButton.link, buttonLabel: messageUsButton.text, buttonVariant: GHOST_VARIANT })));
}
